import axios from 'axios';

axios.defaults.baseURL = 'https://www.jiaonongyipin.cn/';

export function post(url, data) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
    .then( response => {
      resolve(response.data);
    })
    .catch( error => {
      reject(error);
    })
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js